import { baseTokens } from '../base';
import { TenantTokens } from '../types';

/**
 * Sotheby's International Realty Brand Tokens
 *
 * Colors sourced from email template (server/src/services/report/sothebys/styles.ts)
 * Brand identity: Luxury, prestigious, timeless
 */
export const sothebysTokens: TenantTokens = {
  ...baseTokens,
  colors: {
    primary: {
      main: '#012A5C', // Navy - headers, footer, primary actions (from email template)
      light: '#1A4475', // Lighter for hover states
      dark: '#001A3D', // Darker variant
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#C5A47E', // Gold - accent bar, links (from email template)
      light: '#D4B896', // Gold light for gradients
      dark: '#A08040',
      contrastText: '#000000',
    },
    background: {
      default: '#F5F5F5', // Light gray - main app background
      paper: '#FFFFFF', // Cards, dialogs
      subtle: '#FAFAFA', // Table rows, subtle surfaces
    },
    divider: '#E8E8E8', // Border gray for dividers
    text: {
      primary: '#333333', // Main text
      secondary: '#555555', // Medium - secondary text
      disabled: '#888888',
    },
    success: { main: '#2E7D32', light: '#4CAF50', dark: '#1B5E20' },
    warning: { main: '#ED6C02', light: '#FF9800', dark: '#E65100' },
    error: { main: '#D32F2F', light: '#EF5350', dark: '#C62828' },
    info: { main: '#012A5C', light: '#1A4475', dark: '#001A3D' },
  },
  branding: {
    logo: '/logos/sothebys.png',
    logoAlt: "Sotheby's International Realty",
    favicon: '/assets/favicons/sothebys.ico',
  },
};
